import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

interface TitleWrapperProps {
  $fullWidth?: boolean;
}

const TitleWrapper = styled.div<TitleWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
  background-color: #fff;
`;

const Titles = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.h2`
  font: var(--sprout-font-h5);

  @media only screen and (max-width: 700px) {
    font: var(--sprout-font-h6);
  }
`;

export type AccordionTitleProps = {
  title: string;
  count?: number;
  onTitleClick: () => void;
  Subtitle?: ComponentType;
  shouldShowSubtitle?: boolean;
  customTitle?: boolean;
  fullWidth?: boolean;
};

const AccordionTitle = ({
  title,
  count,
  onTitleClick,
  Subtitle,
  shouldShowSubtitle,
  customTitle,
  fullWidth
}: AccordionTitleProps) => {
  const { t } = useTranslation();

  return (
    <TitleWrapper onClick={onTitleClick} $fullWidth={fullWidth}>
      <Titles>
        <Title>
          {customTitle ? title : t(title, { n: count })}
        </Title>
        {shouldShowSubtitle && Subtitle && <Subtitle />}
      </Titles>
    </TitleWrapper>
  );
};

export default AccordionTitle;